export const implement = `<div id="gallery"></div>

<script src="carousel.js"></script>
<script>
    let galleryData = [{
        image: "https://images.pexels.com/photos/3738673/pexels-photo-3738673.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        caption: "<p class='text md'>Owl in the tree</p>"
    }, {
        image: "https://images.pexels.com/photos/3645606/pexels-photo-3645606.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        caption: "<p>Forest</p>"
    }, {
        image: "https://images.pexels.com/photos/3444648/pexels-photo-3444648.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        caption: "<p class='text primary lg'>Lake view</p>"
    }, {
        image: 'https://images.pexels.com/photos/3692550/pexels-photo-3692550.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
        caption: '<p>Autumn</p>'
    }, {
        image: 'https://images.pexels.com/photos/3723034/pexels-photo-3723034.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
        caption: '<p>Wildness civilization</p>'
    }, {
        image: 'https://images.pexels.com/photos/775201/pexels-photo-775201.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260'
    }];


    let galleryCarousel = new Carousel();
    galleryCarousel.constructCarousel('#gallery', galleryData, 'row');
    
    /*
    * Classes can be used:
    ** row, right, left, gap-10 -- gap-100
    ** masonry, masonry bordered, masonry no-gutter
    */
</script>`